import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { MediaClipboardService } from 'media/services/mediaClipboard.service'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class CutOp extends BaseOperation {
  icon = 'far fa-cut'
  showInSelectionToolbar = true
  showInContextMenu = true
  supportsMultiple = true
  supportsDirs = true
  supportsBundles = true
  weight = -11

  constructor (
    translate: TranslateService,
    private mediaClipboard: MediaClipboardService,
    private mediaPermissions: MediaPermissionsService,
  ) {
    super()
    this.label = translate.instant('Cut')
  }

  isVisibleFor () {
    return this.mediaPermissions.permissions.some(x => x.allowWriteFs)
  }

  isEnabledForDir (dir) {
    return dir.present && this.mediaPermissions.getPermissionForFile(dir)?.allowDeleteFs
  }

  isEnabledForBundle (bundle) {
    return bundle.mainfile?.present && this.mediaPermissions.getPermissionForBundle(bundle)?.allowDeleteFs
  }

  async run ({ dirs, bundles }) {
    this.mediaClipboard.copyFiles(dirs, 'cut')
    this.mediaClipboard.copyBundles(bundles, 'cut')
  }
}

MediaOperationsService.register(CutOp)
